// eslint-disable-next-line no-restricted-imports
import styled from "@emotion/styled";

import { darken } from "metabase/ui/colors";

export const LegendRoot = styled.ul<{ isVertical: boolean }>`
  display: flex;
  flex-direction: ${({ isVertical }) => (isVertical ? "column" : "row")};
  list-style: none;
  margin: 0;
  overflow: ${({ isVertical }) => (isVertical ? "" : "hidden")};
  padding: 2px;
`;

export const LegendLink = styled.button`
  background: none;
  border: 0;
  cursor: pointer;
  color: var(--mb-color-core-brand);
  display: block;
  font: inherit;
  font-weight: bold;
  margin: 0;
  padding: 0;
  text-align: left;

  &:hover {
    color: ${() => darken("core-brand")};
  }
`;

export const LegendLinkContainer = styled.li<{ isVertical: boolean }>`
  display: block;
  margin-top: ${({ isVertical }) => (isVertical ? "0.5rem" : "")};
`;

export const LegendPopoverContainer = styled.div`
  padding: 0.5rem;
  overflow-x: hidden;
`;
